import { defineStore } from "pinia"
import UserService from "@/services/rest-auth";

const useUserTokenStore = defineStore('usertoken',{
  state : () => {
    return {
      user: {
        id: null,
        username: null,
        email: null,
        first_name: null,
        last_name: null,
        token: null,
        last_login_event: null,
        is_staff: false,
      }
    }
  },
  getters: {
    username: (state) => state.user.username || null,
    token: (state) => state.user.token || null,
    id: (state) => state.user.id || null,
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setToken(token) {
      this.user.token = token;
    },
    async initialize() {
      UserService.user().then((response) => {
        Object.assign(this.user, response.data); 
      });
    }
  }
});

export {useUserTokenStore};
